import Styles from './FJLoading.module.less';
import classNames from 'classnames';

const FJLoading = props => {
    const { strokeColor = '#fff', style = {}, className } = props;

    const width = style.width || 20;
    const height = style.height || 20;
    return (
        <svg
            viewBox='0 0 50 50'
            className={classNames(Styles.svg_load, className)}
            style={{ width: width, height: height, ...style }}
        >
            <circle cx='25' cy='25' r={25} stroke={strokeColor} fill='none' className={Styles.svg_loading} />
        </svg>
    );
};

export default FJLoading;
